import {ChangeDetectionStrategy, Component, computed, DestroyRef, input, Signal} from "@angular/core";
import {OppgaveModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {EnumOversettelser} from "felles-ng2/tjenester/i18n/EnumOversettelser";
import {FormaterZonedDateRelativTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimeRelativPipe";
import {AsyncPipe} from "@angular/common";
import {oppgaveFristSomPlainDateUTC, OppgavestatusInklOverskredet, oppgaveStatusSomSignal} from "felles-ng2/modell/oppgaveModellHjelpere";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {TranslateModule} from "@ngx-translate/core";
import {FormaterPlainDateRelativTimePipe} from "felles-ng2/pipes/FormaterPlainDateRelativPipe";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MatTooltip} from "@angular/material/tooltip";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {TemporalFormatering} from "felles-ng2/tjenester/TemporalFormatering";

const debug = initDebugger('OppgaveStatusKomponent');

/**
 * Viser oppgavestatus
 */
@Component({
    selector: 'oppgave-status',
    templateUrl: 'oppgave-status.html',
    styleUrl: 'oppgave-status.scss',
    host: {
        '[attr.e2e-oppgave-status]': 'statusnavn()',
        'data-testid': 'oppgave-status'
    },
    imports: [
        FormaterZonedDateRelativTimePipe,
        AsyncPipe,
        TranslateModule,
        FormaterPlainDateRelativTimePipe,
        MatTooltip
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OppgaveStatusKomponent {

    oppgave = input.required<OppgaveModell>();
    modus = input<'boks' | 'utvidet'>('boks');

    frist = computed(() => erIkkeNil(this.oppgave().frist) ? oppgaveFristSomPlainDateUTC(this.oppgave()) : null)
    statusnavn = computed(() => this.enumOversettelser.oversettOppgaveStatus(this.oppgave().status));
    tooltip = computed(() => this.beregnTooltip());
    utvidetStatus: Signal<OppgavestatusInklOverskredet>;
    statuser = OppgavestatusInklOverskredet;

    constructor(private enumOversettelser: EnumOversettelser,
                private oversettelser: Oversettelser,
                private temporalFormatering: TemporalFormatering,
                klokke: Klokke,
                destroyRef: DestroyRef) {
        this.utvidetStatus = oppgaveStatusSomSignal(this.oppgave, klokke, destroyRef);
    }

    //private hjelpemetoder

    private beregnTooltip() {
        if (erIkkeNil(this.oppgave().frist))
            return this.oversettelser.oversett(i18n('Frist {fristDato}'), {fristDato: this.temporalFormatering.formaterPlainDate(oppgaveFristSomPlainDateUTC(this.oppgave()))});
        else
            return this.oversettelser.oversett(i18n('Ingen frist satt'));
    }
}
